<template>
    <ui-sidepage extra-large :close="asyncClose" :go-transparent="true">
        <template v-slot:header>
            <div class="mb-4 mr-12">
                <h3
                    class="text-lg leading-6 font-medium text-gray-900 truncate"
                    id="sidepage-headline"
                    v-text="!editAsAssembly?`${item.reference} • ${item.description}`:'Assembly used in '+assemblyItems.length+' item'+(assemblyItems.length>1?'s':'')"
                ></h3>
                <div v-if="editAsAssembly" class="mt-1 text-sm text-gray-500">
                    <div class="inline-block m-0" v-for="(i,index) in getUsages(item)">
                        <span v-if="index>0" class="mx-1">•</span>Item {{ i.reference }}<span
                        class="text-blue-400 text-xs"> x {{ i.usage }}</span>
                    </div>
                    <div class="text-blue-400 text-xs">Total quantity across all used items : {{
                            getUsages(item).reduce((a, c) => a + c.usage, 0)
                        }} <span v-html="item.uom"></span></div>
                </div>
            </div>
        </template>
        <div class="flex">
            <div class="relative mr-2 mb-1" v-if="editAsAssembly">
                <ui-dropdown menu-class="p-3 w-56" :ref="'iconmenu'">
                    <template #default="{ toggle }">
                        <button @click="toggle" :key="iconKey"
                                class="text-gray-300 w-[30px] h-[24px] ml-px mt-0.5 relative hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:z-10 rounded border border-gray-200">
                            <estimate-assembly-pinger :estimate="estimate" :item="item"
                                                      class="top-1 left-0.5"></estimate-assembly-pinger>
                        </button>
                    </template>
                    <template #menu="{ close }">
                        <ui-dropdown-item icon="fas fa-tint"
                                          @mouseleave="(e) => {$refs['assemblycolormenu'].close(e)}"
                                          @mouseenter="openColorSubmenu"
                                          ref="assemblycolor"
                                          :submenu="true"
                        >
                            Set Colour
                            <div class="fixed" style="width:auto;height:auto;overflow: visible"
                                 :ref="'assemblycolorrelative'">
                                <vue-context :ref="'assemblycolormenu'" :autoFocus="false"
                                             class="inline pb-0 focus:outline-none focus:ring-0 z-30"
                                             :close-on-click="false" :close-on-scroll="false">
                                    <div :id="'assemblycolormenu'"
                                         class="p-3 w-48 z-30 bg-white rounded-lg border border-gray-300 shadow-lg">
                                        <div
                                            v-for="(index,key) in ([0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29])"
                                            class="w-8 inline-block items-center p-1.5 border border-none rounded-lg"
                                            :key="index">
                                            <button
                                                class="w-6 h-6 rounded-lg flex-none mt-0.5 mr-2 inline-block border border-gray-200 hover:border-gray-400"
                                                :style="'background-color: '+color(key)"
                                                @mousedown="setColor(item,color(key))">
                                            </button>
                                        </div>
                                    </div>
                                </vue-context>
                            </div>
                        </ui-dropdown-item>
                        <ui-dropdown-item icon="fas fa-shapes"
                                          @mouseleave="(e) => {$refs['assemblyiconmenu'].close(e)}"
                                          @mouseenter="openIconSubmenu"
                                          ref="assemblyicon"
                                          :submenu="true"
                        >
                            Set Icon
                            <div class="fixed" style="width:auto;height:auto;overflow: visible"
                                 :ref="'assemblyiconrelative'">
                                <vue-context :ref="'assemblyiconmenu'"
                                             class="inline pb-0 focus:outline-none focus:ring-0 z-30"
                                             :close-on-click="false" :close-on-scroll="false">
                                    <div :id="'assemblyiconmenu'" :key="iconKey"
                                         class="p-3 w-56 z-30 bg-white rounded-lg border border-gray-300 shadow-lg">
                                        <ui-dropdown-item
                                            :class="'focus:ring-0'"
                                            @click.prevent.stop="setShape(item,'circle')">
                                            <div class="w-4 h-4 flex-none mt-1 mr-2">
                                                <estimate-assembly-pinger :estimate="estimate" :item="item"
                                                                          :override-shape="'circle'"></estimate-assembly-pinger>
                                            </div>
                                            Circle
                                        </ui-dropdown-item>
                                        <ui-dropdown-item
                                            :class="'focus:ring-0'"
                                            @click.prevent.stop="setShape(item,'square')">
                                            <div class="w-4 h-4 flex-none mt-1 mr-2">
                                                <estimate-assembly-pinger :estimate="estimate" :item="item"
                                                                          :override-shape="'square'"></estimate-assembly-pinger>
                                            </div>
                                            Square
                                        </ui-dropdown-item>
                                        <ui-dropdown-item
                                            :class="'focus:ring-0'"
                                            @click.prevent.stop="setShape(item,'triangle')">
                                            <div class="w-4 h-4 flex-none mt-1 mr-2">
                                                <estimate-assembly-pinger :estimate="estimate" :item="item"
                                                                          :override-shape="'triangle'"></estimate-assembly-pinger>
                                            </div>
                                            Triangle
                                        </ui-dropdown-item>
                                        <ui-dropdown-item
                                            :class="'focus:ring-0'"
                                            @click.prevent.stop="setShape(item,'star')">
                                            <div class="w-4 h-4 flex-none mt-1 mr-2">
                                                <estimate-assembly-pinger :estimate="estimate" :item="item"
                                                                          :override-shape="'star'"></estimate-assembly-pinger>
                                            </div>
                                            Star
                                        </ui-dropdown-item>
                                    </div>
                                </vue-context>
                            </div>
                        </ui-dropdown-item>

                    </template>
                </ui-dropdown>
            </div>
            <label class="flex-1 my-0 py-0 mt-0 text-lg">Item {{
                    editAsAssembly ? 'Assembly Build up' : 'Build up'
                }}</label>
        </div>
        <template v-if="!editAsAssembly">
            <label class="my-0 py-0 mt-0 text-sm font-medium text-gray-700 mb-1">Build up notes</label>
            <ui-form-section class="mt-1">
                <ui-textarea v-model="item.notes" autoresize class="text-xs text-gray-800"
                             :disabled="estimate.readonly"
                             @input="updateEstimate()"></ui-textarea>
                <!--
                <div class="col-span-full" v-else>
                    <div
                        class="m-0 relative rounded-md shadow-sm block w-full p-2 whitespace-pre-wrap border sm:text-sm focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 text-xs"
                        style="min-height: 58px"
                    >{{ item.notes }}
                    </div>
                </div>
                -->
            </ui-form-section>
        </template>
        <hr class="my-3"/>
        <div class="flex">
            <div class="mr-2" :class="editAsAssembly?'w-16':'w-32'">
                <div class="flex w-full mb-2">
                    <ui-input label="Quantity" v-model="quantity" class="w-1/2 mr-2" placeholder="Quantity..."
                              :disabled="estimate.readonly"
                              v-if="!editAsAssembly"
                              @input="updateQuantity"
                              @blur="fixQuantity"></ui-input>
                    <ui-input label="Uom" v-model="item.uom" :disabled="estimate.readonly"
                              @input="updateUom" :class="editAsAssembly?'':'w-1/2'"></ui-input>
                </div>
            </div>
            <div class="flex-1 flex-grow">
                <ui-textarea label="Description" :disabled="estimate.readonly"
                             v-if="!editAsAssembly"
                             v-model="item.description" autoresize rows="1"
                             :class="'sm:col-span-11'"
                             @input="updateDescription"></ui-textarea>
                <ui-textarea label="Assembly Name" :disabled="estimate.readonly"
                             v-else
                             v-model="currentTitle" autoresize rows="1"
                             :class="'sm:col-span-10'"
                             @input="setTitle(item,currentTitle)"></ui-textarea>
            </div>
            <!--
            <div class="w-32 ml-2">
                <label class="block text-sm font-medium text-gray-700 mb-1">Uom Ratios</label>
                <div
                    class="w-full flex border-t border-l border-r border-gray-200 bg-blue-50 rounded-t-lg p-1 text-xs font-medium text-gray-700 ">
                    <div class="w-1/2 flex m-0 relative pl-1">
                        Uom
                    </div>
                    <div class="w-1/2 flex m-0 relative pl-1">
                        Ratio
                    </div>
                </div>
                <div class="w-full flex bg-white text-xs">
                    <div class="flex -mx-px">
                        <div class="w-1/2 flex m-0 relative">
                            <page-cell
                                class="text-xs -my-px ml-0 -mr-px px-1.5 py-0.5 border border-gray-200"
                                v-model="item.r_uom"
                            ></page-cell>
                        </div>
                        <div class="w-1/2 flex m-0 -mr-px relative">
                            <page-cell
                                class="text-xs -my-px -ml-px -mr-px px-1.5 py-0.5 border border-gray-200"
                                v-model="item.r_ratio"
                            ></page-cell>
                        </div>
                    </div>
                </div>
            </div>
            -->
        </div>
        <hr class="my-3"/>
        <!-- Materials and Suppliers Header. -->
        <div class="flex border-t border-l -mb-px border-gray-200 bg-blue-50 mt-3 rounded-t-lg">
            <div class="w-6 h-full flex-shrink-0 self-start py-1.5 m-0">
            </div>
            <div class="w-6 flex -ml-px">
                <div class="text-xs text-gray-200 w-full m-0 px-1 py-1.5 border-r border-gray-200 font-semibold pt-2.5">
                    <svg xmlns="http://www.w3.org/2000/svg" class="opacity-60" width="14" height="14"
                         viewBox="0 0 24 24">
                        <path
                            d="M9.916 8.195h-.013v.961c-.034 1.598 4.213 1.601 4.161 0v-.96c-.123-1.511-4.042-1.52-4.148-.001zm2.08.71c-.723 0-1.311-.253-1.311-.564 0-.312.588-.564 1.311-.564.724 0 1.311.253 1.311.564 0 .311-.587.564-1.311.564zm6.421-2.155v-.96c-.124-1.511-4.042-1.52-4.148-.001h-.013v.961c-.034 1.599 4.214 1.602 4.161 0zm-2.067-1.379c.723 0 1.311.253 1.311.564s-.589.565-1.311.565c-.724 0-1.311-.253-1.311-.564s.587-.565 1.311-.565zm-10.797.418h-.013v.961c-.034 1.598 4.213 1.601 4.161 0v-.96c-.123-1.511-4.042-1.519-4.148-.001zm2.08.711c-.723 0-1.311-.253-1.311-.564s.588-.565 1.311-.565c.724 0 1.311.253 1.311.564s-.588.565-1.311.565zm2.283-2.988l-.013.201v.759c-.034 1.598 4.214 1.602 4.161 0v-.959c-.124-1.512-4.042-1.52-4.148-.001zm3.392.145c0 .311-.588.564-1.311.564-.724 0-1.311-.253-1.311-.564s.587-.564 1.311-.564c.723 0 1.311.253 1.311.564zm-1.308-3.657l-11 6 .009.019-.009-.005v12.118l11 5.868 11-5.869v-12.055l-11-6.076zm-1 21l-8-4.268v-7.133l8 4.401v7zm-8.885-14.464l9.882-5.396 9.917 5.458-9.896 5.385-9.903-5.447zm10.885 7.464l8-4.353v7.085l-8 4.268v-7z"/>
                    </svg>
                </div>
            </div>
            <div class="flex-1 flex -ml-px">
                <div class="m-0 px-px py-px pb+px border-gray-200">
                    <div
                        class="col-span-full m-0 px-2 py-1.5 shadow-none relative hover:z-10 focus:z-20 resize-none text-xs font-semibold">
                        Materials &amp; Suppliers
                    </div>
                </div>
            </div>
            <div class="w-16 -ml-px flex">
                <div class="text-xs m-0 px-1 py-1.5 border-l border-gray-200 font-semibold">
                    <div>Uom</div>
                    <div class="text-xs text-gray-300" v-text="'(per '+item.uom+')'">
                    </div>
                </div>
            </div>
            <div class="w-24 -ml-px flex">
                <div class="text-xs m-0 px-1 py-1.5 border-l border-gray-200 font-semibold">
                    <div>Cost</div>
                    <div class="text-xs text-gray-300">(per item)</div>
                </div>
            </div>
            <div class="w-20 -ml-px flex">
                <div class="text-xs m-0 px-1 py-1.5 border-l border-gray-200 font-semibold">
                    <div>Coverage</div>
                    <div class="text-xs text-gray-300" v-text="'(in '+item.uom+')'">
                    </div>
                </div>
            </div>
            <div class="w-16 -ml-px flex">
                <div class="m-0 px-1 py-1.5 border-l border-gray-200 text-xs font-semibold">
                    <div>Waste</div>
                    <div class="text-xs text-gray-300">(in %)</div>
                </div>
            </div>
            <div class="w-20 -ml-px flex" v-if="!editAsAssembly">
                <div class="m-0 px-1 py-1.5 border-l border-gray-200 text-xs font-semibold">
                    <div>Quantity</div>
                    <div class="text-xs text-gray-300">(of items)</div>
                </div>
            </div>
            <div class="w-28 -ml-px flex" v-if="!editAsAssembly">
                <div class="m-0 px-1 py-1.5 border-l border-gray-200 text-xs font-semibold">Total
                    Cost
                </div>
            </div>
            <div class="w-6 flex-shrink-0 self-start pt-2 m-0 border-none pl-1 pr-1"></div>
        </div>
        <!-- Materials. -->

        <draggable :list="item.materials" draggable=".draggable" handle=".handle" group="materials"
                   @change="reorderedMaterial"
        >
            <estimate-task-item-material
                v-for="(material,index) in item.materials"
                :key="index"
                :material="material"
                :store="store"
                :item="item"
                :editAsAssembly="editAsAssembly"
                :estimate="estimate"
                :material-clipboard="materialClipboard"
                @assemblyUpdated="assemblyUpdated"
                @assemblyItemAdded="assemblyItemAdded"
                @assemblyItemRemoved="assemblyItemRemoved"
                ref="materials">
            </estimate-task-item-material>
        </draggable>

        <!-- New Material. -->

        <div class="flex -mt-px" v-if="!estimate.readonly">
            <div class="w-6 flex-shrink-0 self-center">
                <i class="fa fa-plus text-xs text-gray-300"></i>
            </div>
            <div class="flex-1 border-none -mx-px">
                <input
                    placeholder="Add material item..."
                    class="text-sm -mx-px my-px px-2 py-1.5 border-none shadow-none relative focus:z-10"
                    type="text"
                    v-model="newMaterial.name"
                    @input="addMaterial"
                >
            </div>
            <div class="w-6 flex-shrink-0 self-start pt-2 m-0 border-none pl-0.5 pr-1.5"
                 :key="'dropdownMaterial'+userKey">
                <ui-dropdown menu-class="p-3 w-72" v-if="materialClipboard.length">
                    <template #default="{ toggle }">
                        <button @click="toggle"
                                class="text-gray-300 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:z-10 relative p-1 rounded">
                            <i class="fa fa-ellipsis-h"></i>
                        </button>
                    </template>

                    <template #menu="{ close }">
                        <ui-dropdown-item icon="fas fa-paste" @click="pasteMaterials();close();">
                            {{
                                'Paste Material' + (materialClipboard.length > 1 ? 's' : '') + ' (' + materialClipboard.length + ')'
                            }}
                        </ui-dropdown-item>
                        <hr v-if="1" class="m-1.5"/>
                        <ui-dropdown-item icon="fas fa-clipboard" @click="clearMaterialClipboard();close();">
                            {{ 'Empty Material clipboard' }}
                        </ui-dropdown-item>
                    </template>
                </ui-dropdown>
            </div>
        </div>

        <!-- Labour Header. -->

        <div class="flex border-t border-b -mb-px border-l border-r border-gray-200 bg-blue-50 -mt-px">
            <div class="w-6 flex-shrink-0 self-start py-1.5 m-0">
                <div class="w-5 h-2 flex items-center"></div>
            </div>
            <div class="w-6 flex -ml-px">
                <div class="text-xs text-gray-200 w-full m-0 px-1 py-1.5 border-r border-gray-200 font-semibold pt-2.5">
                    <svg xmlns="http://www.w3.org/2000/svg" class="opacity-60" width="14" height="14"
                         viewBox="0 0 24 24">
                        <path
                            d="M9.916 8.195h-.013v.961c-.034 1.598 4.213 1.601 4.161 0v-.96c-.123-1.511-4.042-1.52-4.148-.001zm2.08.71c-.723 0-1.311-.253-1.311-.564 0-.312.588-.564 1.311-.564.724 0 1.311.253 1.311.564 0 .311-.587.564-1.311.564zm6.421-2.155v-.96c-.124-1.511-4.042-1.52-4.148-.001h-.013v.961c-.034 1.599 4.214 1.602 4.161 0zm-2.067-1.379c.723 0 1.311.253 1.311.564s-.589.565-1.311.565c-.724 0-1.311-.253-1.311-.564s.587-.565 1.311-.565zm-10.797.418h-.013v.961c-.034 1.598 4.213 1.601 4.161 0v-.96c-.123-1.511-4.042-1.519-4.148-.001zm2.08.711c-.723 0-1.311-.253-1.311-.564s.588-.565 1.311-.565c.724 0 1.311.253 1.311.564s-.588.565-1.311.565zm2.283-2.988l-.013.201v.759c-.034 1.598 4.214 1.602 4.161 0v-.959c-.124-1.512-4.042-1.52-4.148-.001zm3.392.145c0 .311-.588.564-1.311.564-.724 0-1.311-.253-1.311-.564s.587-.564 1.311-.564c.723 0 1.311.253 1.311.564zm-1.308-3.657l-11 6 .009.019-.009-.005v12.118l11 5.868 11-5.869v-12.055l-11-6.076zm-1 21l-8-4.268v-7.133l8 4.401v7zm-8.885-14.464l9.882-5.396 9.917 5.458-9.896 5.385-9.903-5.447zm10.885 7.464l8-4.353v7.085l-8 4.268v-7z"/>
                    </svg>
                </div>
            </div>
            <div class="flex-1 flex -ml-px">
                <div class="m-0 px-px py-px pb+px border-gray-200">
                    <div
                        class="col-span-full m-0 px-2 py-1.5 border-none shadow-none relative hover:z-10 focus:z-20 resize-none text-xs font-semibold">
                        Labour
                    </div>
                </div>
            </div>
            <div class="w-24 -ml-px flex">
                <div class="m-0 px-1 py-1.5 border-l border-gray-200 text-xs font-semibold">
                    <div>Rate</div>
                    <div class="text-xs text-gray-300">(per {{ item.uom }})</div>
                </div>
            </div>
            <div class="w-28 -ml-px flex" v-if="!editAsAssembly">
                <div class="m-0 px-2 py-1.5 border-l border-gray-200 text-xs font-semibold">Total Cost
                </div>
            </div>
            <div class="w-6 flex-shrink-0 self-start pt-2 m-0 border-none pl-1 pr-1"></div>
        </div>

        <!-- Labours. -->

        <draggable :list="item.labour" draggable=".draggable" handle=".handle" group="labour" @change="reorderedLabour">
            <estimate-task-item-labour
                v-for="(labour,index) in item.labour"
                :key="index"
                :labour="labour"
                :item="item"
                :editAsAssembly="editAsAssembly"
                :store="store"
                :estimate="estimate"
                :labour-clipboard="labourClipboard"
                ref="labour"
                @assemblyUpdated="assemblyUpdated"
                @assemblyItemAdded="assemblyItemAdded"
                @assemblyItemRemoved="assemblyItemRemoved"
            >
            </estimate-task-item-labour>
        </draggable>

        <!-- New Labour. -->

        <div class="flex -mt-px" v-if="!estimate.readonly">
            <div class="w-6 flex-shrink-0 self-center">
                <i class="fa fa-plus text-xs text-gray-300"></i>
            </div>
            <div class="flex-1 border-none -mx-px">
                <input
                    placeholder="Add labour item..."
                    class="text-sm m-0 my-px px-2 py-1.5 border-none shadow-none relative focus:z-10"
                    type="text"
                    v-model="newLabour.name"
                    @input="addLabour"
                >
            </div>
            <div class="w-6 flex-shrink-0 self-start pt-2 m-0 border-none pl-0.5 pr-1.5"
                 :key="'dropdownLabour'+userKey">
                <ui-dropdown menu-class="p-3 w-64" v-if="labourClipboard.length">
                    <template #default="{ toggle }">
                        <button @click="toggle"
                                class="text-gray-300 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:z-10 relative p-1 rounded">
                            <i class="fa fa-ellipsis-h"></i>
                        </button>
                    </template>

                    <template #menu="{ close }">
                        <ui-dropdown-item icon="fas fa-paste" @click="pasteLabour();close();">
                            {{
                                'Paste Labour' + (labourClipboard.length > 1 ? 's' : '') + ' (' + labourClipboard.length + ')'
                            }}
                        </ui-dropdown-item>
                        <hr v-if="1" class="m-1.5"/>
                        <ui-dropdown-item icon="fas fa-clipboard" @click="clearLabourClipboard();close();">
                            {{ 'Empty Labour clipboard' }}
                        </ui-dropdown-item>
                    </template>
                </ui-dropdown>
            </div>
        </div>

        <!-- Fixed Costs Header. -->

        <div class="flex border-t border-b -mb-px border-l border-r border-gray-200 bg-blue-50 -mt-px">
            <div class="w-6 flex-shrink-0 self-start py-1.5 m-0">
                <div class="w-5 h-2 flex items-center"></div>
            </div>
            <div class="w-6 flex -ml-px">
                <div class="text-xs text-gray-200 w-full m-0 px-1 py-1.5 border-r border-gray-200 font-semibold pt-2">
                    <svg xmlns="http://www.w3.org/2000/svg" class="opacity-60" width="14" height="14"
                         viewBox="0 0 24 24">
                        <path
                            d="M9.916 8.195h-.013v.961c-.034 1.598 4.213 1.601 4.161 0v-.96c-.123-1.511-4.042-1.52-4.148-.001zm2.08.71c-.723 0-1.311-.253-1.311-.564 0-.312.588-.564 1.311-.564.724 0 1.311.253 1.311.564 0 .311-.587.564-1.311.564zm6.421-2.155v-.96c-.124-1.511-4.042-1.52-4.148-.001h-.013v.961c-.034 1.599 4.214 1.602 4.161 0zm-2.067-1.379c.723 0 1.311.253 1.311.564s-.589.565-1.311.565c-.724 0-1.311-.253-1.311-.564s.587-.565 1.311-.565zm-10.797.418h-.013v.961c-.034 1.598 4.213 1.601 4.161 0v-.96c-.123-1.511-4.042-1.519-4.148-.001zm2.08.711c-.723 0-1.311-.253-1.311-.564s.588-.565 1.311-.565c.724 0 1.311.253 1.311.564s-.588.565-1.311.565zm2.283-2.988l-.013.201v.759c-.034 1.598 4.214 1.602 4.161 0v-.959c-.124-1.512-4.042-1.52-4.148-.001zm3.392.145c0 .311-.588.564-1.311.564-.724 0-1.311-.253-1.311-.564s.587-.564 1.311-.564c.723 0 1.311.253 1.311.564zm-1.308-3.657l-11 6 .009.019-.009-.005v12.118l11 5.868 11-5.869v-12.055l-11-6.076zm-1 21l-8-4.268v-7.133l8 4.401v7zm-8.885-14.464l9.882-5.396 9.917 5.458-9.896 5.385-9.903-5.447zm10.885 7.464l8-4.353v7.085l-8 4.268v-7z"/>
                    </svg>
                </div>
            </div>
            <div class="flex-1 flex -ml-px">
                <div class="m-0 px-px py-px pb+px border-gray-200">
                    <div
                        class="col-span-full m-0 px-2 py-1.5 border-none shadow-none relative hover:z-10 focus:z-20 resize-none text-xs font-semibold">
                        Fixed Costs
                        <div class="text-xs text-gray-300 inline-block ml-1">(Not multiplied by item Quantity)</div>
                    </div>
                </div>
            </div>
            <div class="w-20 -ml-px flex">
                <div class="text-xs m-0 px-1 py-1.5 border-l border-gray-200 font-semibold">
                    <div>Quantity</div>
                </div>
            </div>
            <div class="w-24 -ml-px flex">
                <div class="text-xs m-0 px-1 py-1.5 border-l border-gray-200 font-semibold">
                    <div>Uom</div>
                </div>
            </div>
            <div class="w-24 -ml-px flex">
                <div class="text-xs m-0 px-1 py-1.5 border-l border-gray-200 font-semibold">
                    <div>Rate</div>
                </div>
            </div>
            <div class="w-28 -ml-px flex">
                <div class="text-xs m-0 px-1 py-1.5 border-l border-gray-200 font-semibold">Total Cost</div>
            </div>
            <div class="w-6 flex-shrink-0 self-start pt-2 m-0 border-none pl-1 pr-1"></div>
        </div>

        <!-- Fixed Costs. -->

        <draggable :list="item.fixedCosts" draggable=".draggable" handle=".handle" group="fixedCosts"
                   @change="reorderedFixedCosts">
            <estimate-task-item-fixed-cost
                v-for="(fixedCost,index) in item.fixedCosts"
                :key="index"
                :fixedCost="fixedCost"
                :store="store"
                :editAsAssembly="editAsAssembly"
                :item="item"
                :estimate="estimate"
                :fixed-cost-clipboard="fixedCostClipboard"
                ref="fixedCosts"
                @assemblyUpdated="assemblyUpdated"
                @assemblyItemAdded="assemblyItemAdded"
                @assemblyItemRemoved="assemblyItemRemoved"
            >
            </estimate-task-item-fixed-cost>
        </draggable>

        <!-- New Fixed Cost. -->

        <div class="flex -mt-px" v-if="!estimate.readonly">
            <div class="w-6 flex-shrink-0 self-center">
                <i class="fa fa-plus text-xs text-gray-300"></i>
            </div>
            <div class="flex-1 border-none -mx-px">
                <input
                    placeholder="Add fixed cost item..."
                    class="text-sm -mx-px my-px px-2 py-1.5 border-none shadow-none relative focus:z-10"
                    type="text"
                    v-model="newFixedCost.description"
                    @input="addFixedCost"
                >
            </div>
            <div class="w-6 flex-shrink-0 self-start pt-2 m-0 border-none pl-0.5 pr-1.5" :key="'dropdownFixed'+userKey">
                <ui-dropdown menu-class="p-3 w-72" v-if="fixedCostClipboard.length">
                    <template #default="{ toggle }">
                        <button @click="toggle"
                                class="text-gray-300 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:z-10 relative p-1 rounded">
                            <i class="fa fa-ellipsis-h"></i>
                        </button>
                    </template>

                    <template #menu="{ close }">
                        <ui-dropdown-item icon="fas fa-paste" @click="pasteFixedCosts();close();">
                            {{
                                'Paste FixedCost' + (fixedCostClipboard.length > 1 ? 's' : '') + ' (' + fixedCostClipboard.length + ')'
                            }}
                        </ui-dropdown-item>
                        <hr v-if="1" class="m-1.5"/>
                        <ui-dropdown-item icon="fas fa-clipboard" @click="clearFixedCostClipboard();close();">
                            {{ 'Empty FixedCost clipboard' }}
                        </ui-dropdown-item>
                    </template>
                </ui-dropdown>
            </div>
        </div>

        <!-- Material and Labour totals -->

        <div class="border -mt-px -mb-px border-gray-200 bg-blue-50 rounded-b-lg" v-if="!editAsAssembly">
            <div class="flex">
                <div class="flex-shrink ml-4 mt-4">
                    <estimate-task-item-build-existing-search
                        #default="{ close, open, query, setQuery }"
                        class=""
                        :estimate="estimate"
                        :item="item"
                        @selected:existingItem="pullFromExisting"
                        v-if="!estimate.readonly && estimate.collectedItems && (estimate.collectedItems.items.size > 1)"
                        menuClass="w-96">
                        <div
                            class="text-sm px-4 py-1.5 border border-gray-200 rounded bg-white hover:bg-gray-50 cursor-pointer flex"
                            @click="open">
                            <div class="flex-shrink text-lg mr-2 mt-2"><span class="far fa-object-group"></span></div>
                            <div class="flex-shrink">
                                <div class="whitespace-nowrap">Load from existing item or assembly</div>
                                <div class="text-xs text-gray-500 text-center">(will clear the current buildup)</div>
                            </div>
                        </div>
                    </estimate-task-item-build-existing-search>
                </div>
                <div class="flex-grow">
                    <div class="flex text-right">
                        <div class="flex-1 text-sm px-2 py-0.5">Material Costs:</div>
                        <div class="w-40 m-0 text-sm px-2 py-0.5">
                            <div class="inline-block" v-if="item.quantity">
                                {{ materialsTotal() / (item.quantity ? item.quantity : 1) | toCurrency }}
                            </div>
                            <div v-else class="inline-block text-red-400">???</div>
                            <div class="text-xs text-gray-300 inline-block" v-if="item.uom">(per {{ item.uom }})</div>
                        </div>
                        <div class="w-40 m-0 text-sm px-2 py-0.5">
                            <div class="inline-block" v-if="item.quantity">{{ materialsTotal() | toCurrency }}</div>
                            <div v-else class="inline-block text-red-400">???</div>
                        </div>
                        <div class="w-8"></div>
                    </div>
                    <div class="flex text-right">
                        <div class="flex-1 text-sm px-2 py-0.5">Labour Costs:</div>
                        <div class="w-40 m-0 text-sm px-2 py-0.5">
                            <div class="inline-block" v-if="item.quantity">
                                {{ labourTotal() / (item.quantity ? item.quantity : 1)| toCurrency }}
                            </div>
                            <div v-else class="inline-block text-red-400">???</div>
                            <div class="text-xs text-gray-300 inline-block" v-if="item.uom">(per {{ item.uom }})</div>
                        </div>
                        <div class="w-40 m-0 text-sm px-2 py-0.">
                            <div class="inline-block" v-if="item.quantity">{{ labourTotal() | toCurrency }}</div>
                            <div v-else class="inline-block text-red-400">???</div>
                        </div>
                        <div class="w-8"></div>
                    </div>
                    <div class="flex text-right">
                        <div class="flex-1 text-sm px-2 py-0.5">Fixed Costs:</div>
                        <div class="w-40 m-0 text-sm px-2 py-0.5">
                            <div class="inline-block">
                                {{ fixedCostTotal() / (item.quantity ? item.quantity : 1) | toCurrency }}
                            </div>
                            <div class="text-xs text-gray-300 inline-block" v-if="item.uom">(per {{ item.uom }})</div>
                        </div>
                        <div class="w-40 m-0 text-sm px-2 py-0.">
                            <div class="inline-block">{{ fixedCostTotal() | toCurrency }}</div>
                        </div>
                        <div class="w-8"></div>
                    </div>
                    <div class="flex text-right">
                        <div class="flex-1 text-sm font-semibold px-2 py-0.5">Total Cost:</div>
                        <div class="w-40 m-0 text-sm px-2 font-semibold py-0.5">
                            <div class="inline-block" v-if="item.quantity">
                                {{
                                    (materialsTotal() + labourTotal() + fixedCostTotal()) / (item.quantity ? item.quantity : 1) | toCurrency
                                }}
                            </div>
                            <div v-else class="inline-block text-red-400">???</div>
                            <div class="text-xs text-gray-300 inline-block" v-if="item.uom">(per {{ item.uom }})</div>
                        </div>
                        <div class="w-40 m-0 text-sm px-2 font-semibold py-0.5">
                            <div class="inline-block" v-if="item.quantity">
                                {{ materialsTotal() + labourTotal() + fixedCostTotal() | toCurrency }}
                            </div>
                            <div v-else class="inline-block text-red-400">???</div>
                        </div>
                        <div class="w-8"></div>
                    </div>
                </div>
            </div>
            <hr class="m-2"/>
            <div class="flex text-right py-0.5">
                <div class="flex-1 text-sm px-2 py-0.5">Overheads</div>
                <div class="flex w-56 mr-8 relative" v-if="materialsTotal() + labourTotal() + fixedCostTotal() > 0">
                    <ui-input v-model="overheadsPercent" disabled field="py-0.5 text-right " class="w-[5.5rem] mr-1"
                              placeholder="0%"></ui-input>
                    <ui-input v-model="overheads" disabled field="py-0.5 text-right" class="flex-1"
                              placeholder="0%"></ui-input>
                </div>
                <div class="flex w-56 mr-8 relative" v-else>
                    <ui-input value="???" disabled field="py-0.5 text-right text-red-300" class="w-[5.5rem] mr-1"
                              placeholder="0%"></ui-input>
                    <ui-input value="???" disabled field="py-0.5 text-right text-red-300" class="flex-1"
                              placeholder="0%"></ui-input>
                </div>
            </div>
            <div class="flex text-right py-0.5">
                <div class="flex-1 text-sm px-2 py-0.5">Profit</div>
                <div class="flex w-56 mr-8 relative" v-if="materialsTotal() + labourTotal() + fixedCostTotal() > 0">
                    <ui-input v-model="profitPercent" field="py-0.5 text-right " class="w-[5.5rem] mr-1"
                              @input="updateProfitPercent" @change="profitChanged" :disabled="estimate.readonly"
                              :placeholder="estimate.profit+'%'"></ui-input>
                    <ui-input v-model="profit" field="py-0.5 text-right" class="flex-1"
                              @input="updateProfit" @change="profitChanged" :disabled="estimate.readonly"
                              placeholder="0%"></ui-input>
                    <div class="absolute" style="top:0.5rem; left:0.5rem"
                         v-if="item.fixedProfit && item.profitPercent !== estimate.profit">
                        <i class="fas"
                           :class="item.profitPercent < estimate.profit?'text-red-600 fa-arrow-down':'text-green-600 fa-arrow-up'"
                           style="font-size: 9px"></i>
                    </div>
                </div>
                <div class="flex w-56 mr-8 relative" v-else>
                    <ui-input value="???" disabled field="py-0.5 text-right text-red-300" class="w-[5.5rem] mr-1"
                              placeholder="0%"></ui-input>
                    <ui-input value="???" disabled field="py-0.5 text-right text-red-300" class="flex-1"
                              placeholder="0%"></ui-input>
                </div>
            </div>
            <div class="flex text-right py-0.5">
                <div class="flex-1 text-sm px-2 py-0.5">Total after Overheads & Profit</div>
                <div class="flex w-56 mr-8 relative">
                    <ui-input v-model="markedUpTotalValue" @input="updateTotal" @blur="fixTotal"
                              field="py-0.5 text-right" class="flex-1" :disabled="estimate.readonly"
                              :placeholder="item.buildTotal*(1+(estimate.profit+estimate.overheads)/100) | toCurrency()"></ui-input>
                    <div class="absolute" style="top:0.5rem; left:0.5rem" v-if="item.markupFixedValue">
                        <i class="fas fa-star text-blue-600" style="font-size: 8px"></i>
                    </div>
                </div>
            </div>
            <hr class="m-2"/>
            <div class="flex text-right">
                <div class="flex-1 text-sm px-2 py-0.5">Less any item specific discount:</div>
                <div class="flex w-56 mr-0 py-0.5">
                    <ui-input v-model="discountPercent" @input="updateDiscountPercent" @blur="fixDiscount"
                              field="py-0.5 text-right " class="w-[5.5rem] mr-1" :disabled="estimate.readonly"
                              placeholder="0%"></ui-input>
                    <ui-input v-model="discountValue" @input="updateDiscount" @blur="fixDiscount"
                              field="py-0.5 text-right" class="flex-1" :disabled="estimate.readonly"
                              placeholder="£0.00"></ui-input>
                </div>
                <div class="px-2 py-0.5">=</div>
                <div class="flex w-56 mr-8">
                    <ui-input v-model="afterDiscountValue" @input="updateAfterDiscount" @blur="fixDiscount"
                              field="py-0.5 text-right" class="flex-1" :disabled="estimate.readonly"
                              :placeholder="markedUpTotalValue"></ui-input>
                </div>
            </div>
            <div class="flex text-right">
                <div class="flex-1 text-sm px-2 py-0.5">Less any estimate adjustment:</div>
                <div class="flex w-56 mr-0 py-0.5">
                    <ui-input v-model="adjustmentPercent" disabled field="py-0.5 text-right" class="w-[5.5rem] mr-1"
                              placeholder="0%"></ui-input>
                    <ui-input v-model="adjustmentValue" disabled field="py-0.5 text-right" class="flex-1"
                              placeholder="0%"></ui-input>
                </div>
                <div class="px-2 py-0.5">=</div>
                <div class="flex w-56 mr-8">
                    <ui-input v-model="afterAdjustmentValue" disabled
                              field="py-0.5 text-right" class="flex-1"
                              placeholder="£123.45"></ui-input>
                </div>
            </div>
            <div class="flex text-right">
                <div class="flex-1 text-sm px-2 py-0.5">Less any MCD:</div>
                <div class="flex w-56 mr-0 py-0.5">
                    <ui-input v-model="mcdPercent" disabled field="py-0.5 text-right " class="w-[5.5rem] mr-1"
                              placeholder="0%"></ui-input>
                    <ui-input v-model="mcdValue" disabled field="py-0.5 text-right" class="flex-1"
                              placeholder="0%"></ui-input>
                </div>
                <div class="px-2 py-0.5">=</div>
                <div class="flex w-56 mr-8">
                    <ui-input v-model="afterMcdValue" @input="updateTotal" @blur="fixTotal" disabled
                              field="py-0.5 text-right" class="flex-1"
                              placeholder="£123.45"></ui-input>
                </div>
            </div>
            <hr class="m-2"/>
            <div class="flex text-right">
                <div class="flex-1 text-sm font-semibold px-2 py-0.5">Line Item Total:</div>
                <div class="w-40 m-0 text-sm px-2 py-0.5 font-semibold" v-if="item.quantity">
                    {{ lineItemTotalValue | toCurrency }}
                </div>
                <div v-else class="w-40 m-0 text-sm px-2 py-0.5 font-semibold text-red-400">???</div>
                <div class="w-8"></div>
            </div>

        </div>
        <div class="border -mt-px -mb-px border-gray-200 bg-blue-50 rounded-b-lg" v-else>
            &nbsp
        </div>

    </ui-sidepage>
</template>

<script>
import draggable from "vuedraggable"
import EstimateTaskItemMaterial from "./EstimateTaskItemMaterial.vue"
import UiTextarea from "../../../ui/UiTextarea.vue"
import AutoresizableTextarea from "../../../ui/AutoresizableTextarea"
import UiDropdownItem from "../../../ui/UiDropdownItem.vue"
import {cloneDeep, isNull} from "lodash"
import EstimateTaskItemMaterialSearch from "./EstimateTaskItemMaterialSearch.vue"
import EstimateTaskItemFixedCost from "./EstimateTaskItemFixedCost.vue"
import {resolveNumericText, toCurrency} from "../../../../utils"
import EstimateTaskItemTotals from "./EstimateTaskItemTotals.vue"
import UiField from "../../../ui/UiField.vue"
import UiFormSection from "../../../ui/UiFormSection.vue"
import UiSidepage from "../../../ui/UiSidepage.vue"
import UiInput from "../../../ui/UiInput.vue"
import remoteStorage from "../../../../utils/remoteStorage"
import User from "../../../../services/User"
import {Estimate} from "@models"
import UiDropdown from "../../../ui/UiDropdown.vue"
import EstimateTaskItemLabour from "./EstimateTaskItemLabour.vue"
import EstimateAssemblyPinger from "../EstimateAssemblyPinger.vue";
import UiDropdownDivider from "../../../ui/UiDropdownDivider.vue";
import PageCell from "../../../ui/PageCell.vue";
import UiButtonNew from "../../../ui/UiButtonNew.vue";
import PurchaseOrderPackageSearch from "../../../procurement/purchase-orders/PurchaseOrderPackageSearch.vue";
import EstimateTaskItemBuildExistingSearch from "./EstimateTaskItemBuildExistingSearch.vue";

export default {
    components: {
        EstimateTaskItemBuildExistingSearch,
        PurchaseOrderPackageSearch,
        UiButtonNew,
        PageCell,
        UiDropdownDivider,
        EstimateAssemblyPinger,
        EstimateTaskItemLabour,
        UiDropdown,
        UiInput,
        UiSidepage,
        UiFormSection,
        UiField,
        EstimateTaskItemTotals,
        EstimateTaskItemMaterialSearch,
        UiDropdownItem,
        AutoresizableTextarea,
        UiTextarea,
        EstimateTaskItemMaterial,
        EstimateTaskItemFixedCost,
        draggable
    },
    props: {
        item: Object,
        editAsAssembly: false,
        estimate: Object,
        store: Object,
        close: Function,
    },
    watch: {
        user: {
            handler(newValue, oldValue) {
                if (JSON.stringify(this.materialClipboard) !== JSON.stringify(remoteStorage.getItem('estimate-material-clipboard') ? JSON.parse(remoteStorage.getItem('estimate-material-clipboard')) : [])) {
                    this.materialClipboard = remoteStorage.getItem('estimate-material-clipboard') ? JSON.parse(remoteStorage.getItem('estimate-material-clipboard')) : []
                }
                if (JSON.stringify(this.labourClipboard) !== JSON.stringify(remoteStorage.getItem('estimate-labour-clipboard') ? JSON.parse(remoteStorage.getItem('estimate-labour-clipboard')) : [])) {
                    this.labourClipboard = remoteStorage.getItem('estimate-labour-clipboard') ? JSON.parse(remoteStorage.getItem('estimate-labour-clipboard')) : []
                }
                if (JSON.stringify(this.fixedCostClipboard) !== JSON.stringify(remoteStorage.getItem('estimate-fixed-cost-clipboard') ? JSON.parse(remoteStorage.getItem('estimate-fixed-cost-clipboard')) : [])) {
                    this.fixedCostClipboard = remoteStorage.getItem('estimate-fixed-cost-clipboard') ? JSON.parse(remoteStorage.getItem('estimate-fixed-cost-clipboard')) : []
                }
            },
            deep: true
        },
        item: {
            handler(newValue, oldValue) {
                this.$nextTick(() => {
                    if (this.$refs['materials']) {
                        this.$refs['materials'].forEach((material) => {
                            if (material.$refs['autoresizable-textarea']) {
                                material.$refs['autoresizable-textarea'].resizeTextarea({target: material.$refs['autoresizable-textarea'].$el})
                            }
                        })
                    }
                    if (this.$refs['labour']) {
                        this.$refs['labour'].forEach((labour) => {
                            if (labour.$refs['autoresizable-textarea']) {
                                labour.$refs['autoresizable-textarea'].resizeTextarea({target: labour.$refs['autoresizable-textarea'].$el})
                            }
                        })
                    }
                    if (this.$refs['fixedCost']) {
                        this.$refs['fixedCost'].forEach((fixedCost) => {
                            if (fixedCost.$refs['autoresizable-textarea']) {
                                fixedCost.$refs['autoresizable-textarea'].resizeTextarea({target: fixedCost.$refs['autoresizable-textarea'].$el})
                            }
                        })
                    }
                })
                if (this.updating !== 'total') {
                    this.item.setTotal = false
                    this.markedUpTotalValue = toCurrency(this.item.buildTotalMarkedUp)
                }
                if (this.updating !== 'discount') {
                    this.discountValue = '-' + toCurrency(this.item.discount)
                    this.discountPercent = Math.round(this.item.discountPercent * 100) / 100 + '%'
                    this.afterDiscountValue = toCurrency(Math.round((this.item.buildTotalMarkedUp - this.item.discount) * 100) / 100)
                }
                if (this.updating !== 'markup') {
                    this.markupPercent = this.item.buildTotal ? Math.round(this.item.markup * 100) / 100 + '%' : '∞'
                }
                if (newValue.buildTotal !== oldValue.buildTotal) {
                    if (newValue.buildTotal === 0) {
                        this.markupPercent = '0%'
                    } else {
                        this.item.markupFixedValue = null
                    }
                }
                this.overheadsPercent = Math.round(this.estimate.overheads * 100) / 100 + '%'
                this.overheads = toCurrency((Math.round(this.item.overheads * 100) / 100))
                if (this.updating !== 'profit') {
                    this.profitPercent = Math.round(this.item.profitPercent * 100) / 100 + '%'
                    this.profit = toCurrency((Math.round(this.item.profit * 100) / 100))
                }
                this.adjustmentValue = '-' + toCurrency(Math.round(this.item.adjustment * 100) / 100)
                this.adjustmentPercent = Math.round(this.estimate.adjustment * 100) / 100 + '%'
                this.afterAdjustmentValue = toCurrency(Math.round((this.item.buildTotalMarkedUp - this.item.discount - this.item.adjustment) * 100) / 100)
                this.mcdValue = '-' + toCurrency(Math.round(this.item.mcd * 100) / 100)
                this.mcdPercent = Math.round(this.estimate.mcd * 100) / 100 + '%'
                this.afterMcdValue = toCurrency(Math.round((this.item.buildTotalMarkedUp - this.item.discount - this.item.adjustment - this.item.mcd) * 100) / 100)
                this.lineItemTotalValue = this.afterMcdValue
            },
            deep: true,
        },
        "estimate.collectionBuildUUID": {
            handler(newValue, oldValue) {
                this.iconKey++
            },
            deep: true,
        },
    },
    computed: {},
    data() {
        let materialClipboardData = []
        let labourClipboardData = []
        let fixedCostClipboardData = []
        try {
            materialClipboardData = remoteStorage.getItem('estimate-material-clipboard') ? JSON.parse(remoteStorage.getItem('estimate-material-clipboard')) : []
            labourClipboardData = remoteStorage.getItem('estimate-labour-clipboard') ? JSON.parse(remoteStorage.getItem('estimate-labour-clipboard')) : []
            fixedCostClipboardData = remoteStorage.getItem('estimate-fixed-cost-clipboard') ? JSON.parse(remoteStorage.getItem('estimate-fixed-cost-clipboard')) : []
        } catch (e) {
            //continue on JSON ERROR
        }
        return {
            quantity: this.item.quantity,
            markupPercent: this.item.buildTotal ? ((Math.round(this.item.markup * 100) / 100) + '%') : '∞',
            markedUpTotalValue: toCurrency(Math.round(this.item.buildTotalMarkedUp * 100) / 100),
            discountValue: '-' + toCurrency(Math.round(this.item.discount * 100) / 100),
            discountPercent: Math.round(this.item.discountPercent * 100) / 100 + '%',
            afterDiscountValue: toCurrency(Math.round((this.item.buildTotalMarkedUp - this.item.discount) * 100) / 100),
            adjustmentValue: '-' + toCurrency(Math.round(this.item.adjustment * 100) / 100),
            adjustmentPercent: Math.round(this.estimate.adjustment * 100) / 100 + '%',
            afterAdjustmentValue: toCurrency(Math.round((this.item.buildTotalMarkedUp - this.item.discount - this.item.adjustment) * 100) / 100),
            mcdValue: '-' + toCurrency(Math.round(this.item.mcd * 100) / 100),
            mcdPercent: Math.round(this.estimate.mcd * 100) / 100 + '%',
            afterMcdValue: toCurrency(Math.round((this.item.buildTotalMarkedUp - this.item.discount - this.item.adjustment - this.item.mcd) * 100) / 100),
            lineItemTotalValue: toCurrency(Math.round((this.item.buildTotalMarkedUp - this.item.discount - this.item.adjustment - this.item.mcd) * 100) / 100),
            overheadsPercent: Math.round(this.estimate.overheads * 100) / 100 + '%',
            overheads: toCurrency((Math.round(this.item.overheads * 100) / 100)),
            profitPercent: Math.round(this.item.profitPercent * 100) / 100 + '%',
            profit: toCurrency((Math.round(this.item.profit * 100) / 100)),
            newMaterial: {
                name: null,
            },
            newLabour: {
                name: null,
            },
            newFixedCost: {
                description: null,
            },
            materialClipboard: materialClipboardData,
            labourClipboard: labourClipboardData,
            fixedCostClipboard: fixedCostClipboardData,
            updating: false,
            resolveNumericText,
            itemSignature: JSON.stringify(this.estimate.except(['saving', 'saveAgain'])),
            user: Object,
            userKey: 1,
            iconKey: 0,
            assemblyItems: this.editAsAssembly ? this.estimate.collectedItems.items.get(Estimate.itemAsKey(this.item)).items : [],
            currentColor: '#FFFFFF',
            currentShape: 'circle',
            currentTitle: '',
        }
    },
    async mounted() {
        this.user = User.user
        if (this.editAsAssembly) {
            this.currentColor = this.estimate.getColor(this.item)
            this.currentShape = this.estimate.getShape(this.item)
            this.currentTitle = this.estimate.getTitle(this.item)
        }
    },
    methods: {
        pullFromExisting(item) {
            let clone = cloneDeep(item)
            Object.assign(this.item, {
                materials: clone.materials,
                labour: clone.labour,
                fixedCosts: clone.fixedCosts,
                uom: clone.uom
            })
            this.updateEstimate();
        },
        getUsages(item) {
            return this.assemblyItems.filter((i) => {
                if (!isNull(i.bundle)) {
                    return i.bundle.some((i2) => Estimate.itemAsKey(item) === Estimate.itemAsKey(i2))
                } else {
                    return Estimate.itemAsKey(item) === Estimate.itemAsKey(i)
                }
            }).map((i) => {
                let usageCount = 0;
                if (!isNull(i.bundle)) {
                    usageCount = i.bundle.filter((i) => Estimate.itemAsKey(item) === Estimate.itemAsKey(i)).reduce((a, c) => a + Number(c.quantity), 0)
                } else {
                    usageCount = Number(i.quantity)
                }
                return {
                    reference: i.reference,
                    usage: usageCount
                };
            })
        },
        assemblyUpdated(item) {
            this.assemblyItems.forEach((i) => {
                i.uom = item.uom
//                i.description = item.description
                i.materials.forEach((m, index) => {
                    m.component = item.materials[index].component
                    m.uom = item.materials[index].uom
                    m.cost = item.materials[index].cost
                    m.name = item.materials[index].name
                    m.supplier = item.materials[index].supplier
                    m.coverage = item.materials[index].coverage
                    m.waste = item.materials[index].waste
                })
                i.labour.forEach((l, index) => {
                    l.component = item.labour[index].component
                    l.name = item.labour[index].name
                    l.rate = item.labour[index].rate
                })
                i.fixedCosts.forEach((f, index) => {
                    f.component = item.fixedCosts[index].component
                    f.description = item.fixedCosts[index].description
                    f.quantity = item.fixedCosts[index].quantity
                    f.unit = item.fixedCosts[index].unit
                    f.rate = item.fixedCosts[index].rate
                    f.total = item.fixedCosts[index].total
                })
            })
            this.updateEstimate()
        },
        updateEstimate() {
            if (this.editAsAssembly) {
                this.estimate.setColor(this.item, this.currentColor)
                this.estimate.setShape(this.item, this.currentShape)
                this.estimate.setTitle(this.item, this.currentTitle)
            }
            this.estimate.update()
        },
        assemblyItemAdded(object, type) {
            if (this.editAsAssembly) {
                if (type === 'material') {
                    let index = this.item.materials.indexOf(object)
                    this.assemblyItems.forEach((i) => {
                        if (i !== this.item) {
                            let newObject = cloneDeep(object)
                            newObject.quantity = 0
                            newObject.totalCost = 0
                            newObject.notes = ''
                            i.materials.splice(index, 0, newObject)
                        }
                    })
                }
                if (type === 'labour') {
                    let index = this.item.labour.indexOf(object)
                    this.assemblyItems.forEach((i) => {
                        if (i !== this.item) {
                            let newObject = cloneDeep(object)
                            newObject.totalCost = 0
                            newObject.notes = ''
                            i.labour.splice(index, 0, newObject)
                        }
                    })
                }
                if (type === 'fixedCost') {
                    let index = this.item.fixedCosts.indexOf(object)
                    this.assemblyItems.forEach((i) => {
                        if (i !== this.item) {
                            let newObject = cloneDeep(object)
                            newObject.notes = ''
                            i.fixedCosts.splice(index, 0, newObject)
                        }
                    })
                }
                this.updateEstimate()
            }
        },
        assemblyItemRemoved(object, type) {
            if (type === 'material') {
                let index = this.item.materials.indexOf(object)
                this.assemblyItems.forEach((i) => {
                    if (i !== this.item) {
                        i.materials.splice(index, 1)
                    }
                })
                this.item.materials.splice(index, 1)
            }
            if (type === 'labour') {
                let index = this.item.labour.indexOf(object)
                this.assemblyItems.forEach((i) => {
                    if (i !== this.item) {
                        i.labour.splice(index, 1)
                    }
                })
                this.item.labour.splice(index, 1)
            }
            if (type === 'fixedCost') {
                let index = this.item.fixedCosts.indexOf(object)
                this.assemblyItems.forEach((i) => {
                    if (i !== this.item) {
                        i.fixedCosts.splice(index, 1)
                    }
                })
                this.item.fixedCosts.splice(index, 1)
            }
            this.updateEstimate()
        },
        updateProfitPercent(o) {
            if (o === '' || o === this.estimate.profit) {
                this.item.fixedProfit = false
                o = this.estimate.profit
            } else {
                this.item.fixedProfit = true
            }
            this.updating = 'profit'
            this.item.profitPercent = this.resolveNumericText(o)
            this.item.profit = this.item.buildTotal * (this.item.profitPercent / 100)
            this.updateEstimate()
            this.profit = toCurrency((Math.round(this.item.profit * 100) / 100))
        },
        updateProfit(o) {
            if (o === '') {
                return this.updateProfitPercent('')
            } else {
                this.item.fixedProfit = true
            }
            this.updating = 'profit'
            this.item.profit = this.resolveNumericText(o)
            this.item.profitPercent = this.item.buildTotal ? (this.item.profit / this.item.buildTotal) * 100 : 0
            this.updateEstimate()
            this.profitPercent = Math.round(this.item.profitPercent * 100) / 100 + '%'
            if (this.item.profitPercent === this.estimate.profit) {
                this.item.fixedProfit = false
            }
        },
        profitChanged() {
            this.updating = false
            this.profit = toCurrency((Math.round(this.item.profit * 100) / 100))
            this.profitPercent = Math.round(this.item.profitPercent * 100) / 100 + '%'
        },
        isNull,
        addMaterial() {
            let obj = {
                name: this.newMaterial.name,
                uom: '',
                supplier: '',
                rate: 0,
                quantity: 0,
                waste: 0,
                coverage: 0,
                total: 0,
                notes: '',
            }
            this.item.materials.push(obj)
            this.assemblyItemAdded(obj, 'material')
            this.$nextTick(() => {
                this.$refs.materials[this.$refs.materials.length - 1].$refs.name.focus()
                this.newMaterial.name = ''
            })
        },
        addLabour() {
            let obj = {
                name: this.newLabour.name,
                unit: '',
                rate: 0,
                quantity: 0,
                total: 0,
                notes: '',
            }
            this.item.labour.push(obj)
            this.assemblyItemAdded(obj, 'labour')
            this.$nextTick(() => {
                this.$refs.labour[this.$refs.labour.length - 1].$refs.name.focus()
                this.newLabour.name = ''
            })
        },
        addFixedCost() {
            let obj = {
                description: this.newFixedCost.description,
                unit: '',
                rate: 0,
                quantity: 1,
                total: 0,
                notes: '',
            }
            this.item.fixedCosts.push(obj)
            this.assemblyItemAdded(obj, 'fixedCost')
            this.$nextTick(() => {
                this.$refs.fixedCosts[this.$refs.fixedCosts.length - 1].$refs.description.focus()
                this.newFixedCost.description = ''
            })
        },
        asyncClose() {
            if (this.$refs.materials) {
                this.$refs.materials.forEach((i) => {
                    i.$refs.component.updateComponentsFromEstimate(true);
                });
            }
            if (this.$refs.labour) {
                this.$refs.labour.forEach((i) => {
                    i.$refs.component.updateComponentsFromEstimate(true);
                });
            }
            if (this.$refs.fixedCosts) {
                this.$refs.fixedCosts.forEach((i) => {
                    i.$refs.component.updateComponentsFromEstimate(true);
                });
            }
            if (this.itemSignature !== JSON.stringify(this.estimate.except(['saving', 'saveAgain']))) {
                this.estimate.addSnapshot()
            }
            setTimeout(() => {
                this.close()
            }, 0)
        },
        pasteMaterials() {
            this.materialClipboard.forEach((t, index) => {
                let material = cloneDeep(t)
                this.item.materials.splice(this.item.materials.length, 0, material)
                this.assemblyItemAdded(material, 'material')
            })
            this.updateEstimate()
            this.estimate.addSnapshot()
        },
        clearMaterialClipboard() {
            this.materialClipboard.length = 0
            remoteStorage.setItem('estimate-material-clipboard', JSON.stringify(this.materialClipboard))
        },
        pasteLabour() {
            this.labourClipboard.forEach((t, index) => {
                let labour = cloneDeep(t)
                this.item.labour.splice(this.item.labour.length, 0, labour)
                this.assemblyItemAdded(labour, 'labour')
            })
            this.updateEstimate()
        },
        clearLabourClipboard() {
            this.labourClipboard.length = 0
            remoteStorage.setItem('estimate-labour-clipboard', JSON.stringify(this.labourClipboard))
        },
        pasteFixedCosts() {
            this.fixedCostClipboard.forEach((t, index) => {
                let fixedCost = cloneDeep(t)
                this.item.fixedCosts.splice(this.item.fixedCosts.length, 0, fixedCost)
                this.assemblyItemAdded(fixedCost, 'fixedCost')
            })
            this.updateEstimate()
        },
        clearFixedCostClipboard() {
            this.fixedCostClipboard.length = 0
            remoteStorage.setItem('estimate-fixed-cost-clipboard', JSON.stringify(this.fixedCostClipboard))
        },
        materialsTotal() {
            return this.item.materials.reduce((a, material) => a + material.total, 0)
        },
        labourTotal() {
            return this.item.labour.reduce((a, labour) => a + labour.total, 0)
        },
        fixedCostTotal() {
            return this.item.fixedCosts.reduce((a, fixedCost) => a + fixedCost.total, 0)
        },
        costTotal() {
            return this.materialsTotal() + this.labourTotal() + this.fixedCostTotal()
        },
        reorderedMaterial(e) {
            if (this.editAsAssembly) {
                this.assemblyItems.forEach((i, index) => {
                    if (i !== this.item) {
                        let item = i.materials.splice(e.moved.oldIndex, 1)
                        i.materials.splice(e.moved.newIndex, 0, item[0])
                    }
                })
            }
            this.updateEstimate()
        },
        reorderedLabour(e) {
            if (this.editAsAssembly) {
                this.assemblyItems.forEach((i, index) => {
                    if (i !== this.item) {
                        let item = i.labour.splice(e.moved.oldIndex, 1)
                        i.labour.splice(e.moved.newIndex, 0, item[0])
                    }
                })
            }
            this.updateEstimate()
        },
        reorderedFixedCosts(e) {
            if (this.editAsAssembly) {
                this.assemblyItems.forEach((i, index) => {
                    if (i !== this.item) {
                        let item = i.fixedCosts.splice(e.moved.oldIndex, 1)
                        i.fixedCosts.splice(e.moved.newIndex, 0, item[0])
                    }
                })
            }
            this.updateEstimate()
        },
        updateQuantity() {
            let value = Math.round(this.resolveNumericText(this.quantity) * 1000) / 1000
            this.estimate.setItemQuantity(this.item, isNaN(value) ? 0 : value)
            this.updateEstimate()
        },
        updateDescription() {
            this.assemblyUpdated(this.item)
            this.updateEstimate()
        },
        updateUom() {
            this.assemblyUpdated(this.item)
            this.updateEstimate()
        },
        fixQuantity() {
            this.quantity = this.item.quantity
        },
        updateTotal(val) {
            this.updating = 'total'
            this.item.setTotal = true
            if (this.costTotal()) {
                this.item.markupFixedValue = null
                let markup
                if (val === '') {
                    markup = this.item.buildTotal * ((this.estimate.profit + this.estimate.overheads) / 100)
                } else {
                    markup = Math.round(this.resolveNumericText(val) * 1000) / 1000 - this.item.buildTotal
                }
                this.item.profitPercent = (this.item.buildTotal ? (markup / this.item.buildTotal) * 100 : 0) - this.estimate.overheads
                this.item.fixedProfit = true
                this.profitPercent = Math.round(this.item.profitPercent * 100) / 100 + '%'
            } else {
                this.item.markupFixedValue = Math.round(this.resolveNumericText(val) * 1000) / 1000
            }
            this.updateEstimate()
        },
        fixTotal(val) {
            this.updating = false
            this.markedUpTotalValue = toCurrency(Math.round(this.total() * 100) / 100)
        },
        updateMarkup(val) {
            this.updating = 'markup'
            this.item.markupFixedValue = null
            if (this.costTotal()) {
                this.item.markup = Math.max(-100, Math.round(this.resolveNumericText(val, false) * 1000) / 1000)
            } else {
                this.item.markup = 0
            }
            this.updateEstimate()
            this.markedUpTotalValue = toCurrency(Math.round(this.total() * 100) / 100)
        },
        fixMarkup(val) {
            this.updating = false
            this.markupPercent = this.costTotal() ? Math.round((this.total() / this.costTotal() - 1) * 10000) / 100 + '%' : '∞'
        },
        updateDiscount(val) {
            this.updating = 'discount'
            this.item.discountPercent = Math.min(100, Math.max(0, (Math.round(this.resolveNumericText(val, false) * 100) / 100) / this.item.buildTotalMarkedUp * 100))
            this.updateEstimate()
            this.discountPercent = Math.round(this.item.discountPercent * 100) / 100 + '%'
            this.afterDiscountValue = toCurrency(Math.round((this.item.buildTotalMarkedUp - this.item.discount) * 100) / 100)
        },
        updateDiscountPercent(val) {
            this.updating = 'discount'
            this.item.discountPercent = Math.min(100, Math.max(0, (Math.round(this.resolveNumericText(val) * 100) / 100)))
            this.updateEstimate()
            this.discountValue = toCurrency(Math.round(this.item.discount * 100) / 100)
            this.afterDiscountValue = toCurrency(Math.round((this.item.buildTotalMarkedUp - this.item.discount) * 100) / 100)
        },
        updateAfterDiscount(val) {
            if (val === '') {
                val = this.item.buildTotalMarkedUp
            } else {
                val = this.resolveNumericText(val)
            }
            this.updating = 'discount'
            this.item.discountPercent = Math.min(100, Math.max(0, 100 - (100 / this.item.buildTotalMarkedUp) * this.resolveNumericText(val)))
            this.updateEstimate()
            this.discountPercent = Math.round(this.item.discountPercent * 100) / 100 + '%'
            this.discountValue = toCurrency(Math.round(this.item.discount * 100) / 100)
        },
        fixDiscount(val) {
            this.updating = false
            this.discountValue = toCurrency(Math.round(this.item.discount * 100) / 100)
            this.discountPercent = Math.round(this.item.discountPercent * 100) / 100 + '%'
            this.afterDiscountValue = toCurrency(Math.round((this.item.buildTotalMarkedUp - this.item.discount) * 100) / 100)
        },
        total() {
            return this.item.buildTotalMarkedUp
        },
        color(x) {
            const c = [
                '#FF0000',
                '#00FF00',
                '#0000FF',
                '#FFFF00',
                '#00FFFF',
                '#800000',
                '#9A6324',
                '#808000',
                '#0c541b',
                '#469990',
                '#000075',
                '#e6194B',
                '#f58231',
                '#ffe119',
                '#bfef45',
                '#3cb44b',
                '#42d4f4',
                '#4363d8',
                '#911eb4',
                '#FF00FF',
                '#000000',
                '#595959',
                '#a9a9a9',
                '#fabed4',
                '#ffd8b1',
                '#fffac8',
                '#aaffc3',
                '#dcbeff',
                '#93C3F8',
                '#FFFFFF',
            ]
            return c[x]
        },
        setColor(item, color) {
            this.currentColor = color
            this.updateEstimate()
            this.$refs['assemblycolormenu'].close()
            this.$refs['iconmenu'].close()
            this.iconKey++;
        },
        setShape(item, shape) {
            this.currentShape = shape
            this.updateEstimate()
            this.$refs['assemblyiconmenu'].close()
            this.$refs['iconmenu'].close()
            this.iconKey++;
        },
        setTitle(item, title) {
            this.updateEstimate()
        },
        openColorSubmenu(e) {
            this.$refs["assemblycolormenu"].open(new window.MouseEvent('mouse'))
            this.$nextTick(() => {
                this.$refs["assemblycolorrelative"].setAttribute('style', '')
                this.$nextTick(() => {
                    const opener = this.$refs.assemblycolor.$refs.submenu.getBoundingClientRect()
                    const box = this.$refs["assemblycolor"].$el.getBoundingClientRect()
                    let left = Math.min(opener.x - box.x - 40, window.innerWidth - (box.right) - 17);
                    let top = Math.min(opener.y - box.y - 16, window.innerHeight - (box.bottom) - 28);
                    this.$refs["assemblycolorrelative"].setAttribute('style', 'margin-left:' + left + 'px; margin-top:' + top + 'px')
                })
            })
        },
        openIconSubmenu(e) {
            this.$refs["assemblyiconmenu"].open(new window.MouseEvent('mouse'))
            this.$nextTick(() => {
                this.$refs["assemblyiconrelative"].setAttribute('style', '')
                this.$nextTick(() => {
                    const opener = this.$refs.assemblyicon.$refs.submenu.getBoundingClientRect()
                    const box = this.$refs["assemblyicon"].$el.getBoundingClientRect()
                    let left = Math.min(opener.x - box.x - 40, window.innerWidth - (box.right) - 17);
                    let top = Math.min(opener.y - box.y - 16, window.innerHeight - (box.bottom) - 28);
                    this.$refs["assemblyiconrelative"].setAttribute('style', 'margin-left:' + left + 'px; margin-top:' + top + 'px')
                })
            })
        },
    }
}
</script>
